// extracted by mini-css-extract-plugin
export default {"gallery":"c-q_fJ","gallery__header":"c-q_fK","gallery__thumbs":"c-q_fL"};